import Schema from 'AppReact/schema';
import { filterDropdownOption } from "types";

export default {
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  isReadonly: Schema('boolean', 'primitive', { defaultValue: false }),
  searchTerm: Schema('string', 'primitive', { defaultValue: '' }),
  options: Schema(filterDropdownOption, 'array', { defaultValue: [] }),
  selectedOptionIds: Schema('integer', 'array', { defaultValue: [] }),
  label: Schema("string", "primitive", { defaultValue: '' }),
  pageNumber: Schema('integer', 'primitive', { defaultValue: 1 }),
  width: Schema("string", "primitive-nullable", { defaultValue: null }),
  placeholder: Schema("string", "primitive-nullable", { defaultValue: '' }),
  singleSelect: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  inputRef: Schema({}, 'object', { defaultValue: null }),
  icon: Schema({}, 'object', { defaultValue: null }),
  bold: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  ellipsis: Schema('integer', 'primitive-nullable', { defaultValue: null })
}